export const BRAND_DEALS = [
  {
    id: "1",
    brand: "Project Primal",
    perk: "10% off your order",
    code: "DIBALM10",
    href: "https://project-primal.com/en-lb?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAb21jcARN-HpleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA81NjcwNjczNDMzNTI0MjcAAafVcIIN8PkoNxXDnh7V7zMkxC0_qChqymjHm6qon4ppG7eCbhINXItJW7JZHA_aem_5RpKrx9tOVsHXJo-e2KNIg",
    accentKind: "primary",
  },
  {
    id: "2",
    brand: "Muscle Madness",
    perk: "15% off supplements",
    code: "DIBALM15",
    href: "https://musclemadnesslb.com",
    accentKind: "secondary",
  },
  {
    id: "3",
    brand: "Magneva",
    perk: "15% off Magnesium Recovery Spray",
    code: "DIBAL15",
    href: "https://magnevalb.com",
    accentKind: "secondary",
  }
];

